<template>
  <div class="create-manage card-height">
    <div class="card">
      <h2>Manage Organizations</h2>
      <button class="btn" type="action" @click="onCreateOrgClick($event)">Create Organization</button>
      <button class="btn mt-4" type="action" @click="onCreateUsersClick($event)">Create User</button>
      <button class="btn mt-4" type="action" @click="onManageClick($event)">Manage Orgs</button>
    </div>
  </div>
</template>

<script>
import router from '../../routes/router';
import routeNames from '../../util/routeNames';
import modalNames from '../../util/modalNames';

export default {
  name: 'CreateManage',
  methods: {
    onCreateOrgClick(event) {
      event.preventDefault();
      // TODO: Use imported version of modalNames
      this.$bvModal.show(modalNames.EDIT_ORG_MODAL);
    },
    onCreateUsersClick(event) {
      event.preventDefault();
      this.$bvModal.show(modalNames.CREATE_USER_MODAL);
    },
    onManageClick(event) {
      event.preventDefault();
      router.push(routeNames.ADMINORGS.PATH);
    }
  }
}
</script>

<style lang="scss">
@import "../../styles/vendor/_bootstrap-setup";
@import "../../styles/environment/_variables";

.create-manage {
  text-align: center;

  h2 {
    margin-bottom: 35px;
  }

  .card {
    text-align: center;

    .btn {
      display: block;
      margin: 0 auto;

      @include media-breakpoint-down(sm) {
        min-width: 200px;
      }

      @include media-breakpoint-up(lg) {
        min-width: 100%;
        width: 100%;
      }
    }
  }
}

</style>
